var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19.042,
    viewBox: "0 0 16 19.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profit-report",
    transform: "translate(-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11554",
    "data-name": "Group 11554",
    transform: "translate(74.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11553",
    "data-name": "Group 11553",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18973",
    "data-name": "Path 18973",
    d: "M320,0V4.988h5.333Z",
    transform: "translate(-320)",
    fill: "#adafb3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11556",
    "data-name": "Group 11556",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11555",
    "data-name": "Group 11555",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18974",
    "data-name": "Path 18974",
    d: "M74.667,5.95a1.27,1.27,0,0,1-1.333-1.19V0h-8A1.27,1.27,0,0,0,64,1.19V17.851a1.269,1.269,0,0,0,1.333,1.19H78.667A1.268,1.268,0,0,0,80,17.851V5.95ZM69.333,16.661H66.667v-3.57h2.667Zm4,0H70.667v-5.95h2.667Zm4,0H74.667V8.331h2.667Z",
    transform: "translate(-64)",
    fill: "#adafb3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.fadd50e4b8a813bb9455df4377342339.svg";
export { ForwardRef as ReactComponent };